import { render, staticRenderFns } from "./ShiftType.vue?vue&type=template&id=0d81c093"
import script from "./ShiftType.vue?vue&type=script&lang=ts"
export * from "./ShiftType.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports